import _ from 'lodash';
import IApplicationState from 'app/types/state';

export function getCurrentMatchPayment(state: IApplicationState) {
  if (
    state.matchPayments.matchPaymentsById !== undefined
    && state.matchPayments.currentMatchPaymentId !== undefined
  ) {
    const pc = state.matchPayments.matchPaymentsById[
      state.matchPayments.currentMatchPaymentId
    ];
    if (
      !_.isEmpty(pc)
      && !_.isEmpty(pc.fixtureMatch)
      && !_.isEmpty(state.paymentEvents.paymentEventsById)
    ) {
      return {
        ...pc,
        paymentEvent: {
          ...state.paymentEvents.paymentEventsById[pc.fixtureMatch.id],
        },
        competition: {
          ...state.competitions.competitionsById[pc.competition?.id],
        },
        fixtureMatch: {
          ...state.paymentEvents.paymentEventsById[pc.fixtureMatch.id],
        },
      };
    }
    return pc;
  }
  return {};
}

export function getCurrentFormMatchPayment(state: IApplicationState) {
  return {
    ...getCurrentMatchPayment(state),
    ...state.matchPayments.requestedData,
  };
}

export function getMatchPayments(state: IApplicationState) {
  return {
    ...state.matchPayments,
    currentMatchPayment: {
      ...getCurrentMatchPayment(state),
    },
  };
}

export function getMatchPaymentIdsByTeamId(
  matchPaymentsById: any,
  teamId,
) {
  if (matchPaymentsById !== undefined && teamId != null) {
    const filtered = _.filter(matchPaymentsById, {
      teamId,
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}

export function getMatchPaymentIdsByPaymentId(
  state: IApplicationState,
  paymentId,
) {
  if (
    state.matchPayments.matchPaymentsById !== undefined
    && paymentId != null
  ) {
    const { matchPaymentsById } = state.matchPayments;
    const filtered = _.filter(matchPaymentsById, {
      payment: { id: paymentId },
    });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
